import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CustomformComponent } from '../../catalog/customform/customform.component';

export namespace NCmsCustomform {
    export const componentId = 'button';

    export interface IComponentData extends NICmsContentComponent.IData {
        form_identifier?: string;
        newsletter_source?: string;
    }
}

/**
 * Customform component.
 *
 * @usage
 *
 * ## Normal
 * `PageComponentCustomformModule` must be added to `CatalogModule` `imports`.
 *
 * ```html
 * <cms-component-customform [component]="component"></cms-component-customform>
 * ```
 *
 * @input component
 */
@ICmsComponent<CmsCustomFormComponent>({
    id: 'customform',
    name: 'Custom Form',
    isAdvanced: false,
    description: 'Custom form from Landofcoders Magento plugin',
    tags: ['form', 'custom'],
    hidePreview: true,
    fields: [
        {
            key: 'form_identifier',
            type: NICmsContentField.EFieldType.text,
            title: 'Form Identifier'
        },
        {
            key: 'newsletter_source',
            type: NICmsContentField.EFieldType.text,
            title: 'Newsletter Source'
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    selector: 'cms-component-customform',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CustomformComponent],
    template: `
        @if (component) {
            <customform [identifier]="component.form_identifier || ''" [source]="component.newsletter_source || ''"></customform>
        }
    `
})
export class CmsCustomFormComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsCustomform.IComponentData;
}
